import request from '@/utils/request'



export function submit(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}

export function getList(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}

export function approvalList(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}

export function submitList(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}

export function derails(data) {
    return request({
        url: '',
        method: 'post',
        data
    })
}


